import { type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { UtilBox } from '../lib/fleetUtilization';
import { taskLine } from '../lib/machine-labels';
import { shownJob, shownJobStateKey } from '../lib/shown-job';

// The List view's Doing now cell (#6561; the jobs list #6745): the job `shownJob` picks —
// the machine's oldest RUNNING job, else its oldest job with its state — then "+N more
// jobs" when it holds more, then THAT job's repo on a working machine. The line and the repo
// read one pick, so they can never name two different jobs. No job reads the machine's
// status sentence (`taskLine`).

export function MachineTaskCell(props: { readonly box: UtilBox }): JSX.Element {
  const jobs = () => props.box.jobs ?? [];
  const shown = () => shownJob(props.box);
  const stateKey = () => {
    const s = shown();
    return s === null || s.running ? null : shownJobStateKey(s.job);
  };
  return (
    <span class="machine-row__stack">
      <span class="machine-row__task" data-task={shown() === null ? undefined : ''}>
        {taskLine(props.box, t)}
      </span>
      <Show when={stateKey()}>{(key) => <span class="machine-row__sub">{t(key())}</span>}</Show>
      <Show when={jobs().length > 1}>
        <span class="machine-row__sub">
          {tPlural('fleet.machines.job_more', jobs().length - 1, { count: jobs().length - 1 })}
        </span>
      </Show>
      <Show when={props.box.verdict.status === 'working' && shown()?.job.repo}>
        {(repo) => <span class="machine-row__sub">{repo()}</span>}
      </Show>
    </span>
  );
}
